import financialImg from "../../../img/test-images/SSS-result-images/financial.svg";
import familyImg from "../../../img/test-images/SSS-result-images/family.svg";
import socialImg from "../../../img/test-images/SSS-result-images/social.svg";
import educationImg from "../../../img/test-images/SSS-result-images/education.svg";
import egoThreatImg from "../../../img/test-images/SSS-result-images/ego-threat.svg";
import bereavementImg from "../../../img/test-images/SSS-result-images/bereavement.svg";
import separationImg from "../../../img/test-images/SSS-result-images/separation.svg";
import setBackImg from "../../../img/test-images/SSS-result-images/setback.svg";
import healthImg from "../../../img/test-images/SSS-result-images/health.svg";

const questions = [
    "Theft of wealth and property",
    "Theft or loss of a personally valuable possession",
    "Major financial trouble arose",
    "Family income decreased heavily",
    "Relations with some family member got strained",
    "Family member interfered in personal matters",
    "Family environment got tense",
    "Parents favored siblings",
    "Serious differences arose with a friend or a neighbor",
    "Relations with an authority (hostel warden, faculty, etc) deteriorated",
    "Relations with your romantic partner got strained",
    "Parents did not trust me on certain occasions",
    "People behaved indifferently towards me",
    "People misunderstoof me",
    "Compared to others, I found myself inferior",
    "Physical beauty diminished",
    "Aspiration of my life remained unfulfilled",
    "I was not honored for the commendable work I did",
    "I was blamed when I wasn't at fault",
    "Parents scholded or hit me",
    "Got scolded by an authority",
    "My family was dishonored",
    "Passed exam with poor marks",
    "Failed in examination",
    "Disciplinary action was taken against me",
    "A family member was jailed",
    "Got apprehended for a simple breach of law",
    "A close friend died",
    "A close family member died",
    "A pet died",
    "A relative died",
    "A family member was missing",
    "Separated from someone close to me",
    "Engagement was broken",
    "Could not marry the person I loved",
    "Family members frequently got ill",
    "A family member was admitted in the hospital",
    "A family member developed a mental illness",
    "A close friend/relative developed a serious disease",
    "Major deterioration of health of a family member (but not admitted to the hospital)",
    "Started living at a friend's/relative's place",
    "Started living in a hired room",
    "Major decrease in outings and social activities",
    "Appeared in exam despite ill health",
    "Could not appear in exam due to illness or some other reason",
    "I had to choose a subject I was not interested in",
    "Course was not completed in the class",
    "Could not secure admission in an important class or course",
    "Indiscipline increased in the university",
    "Teacher acted partially",
    "I had inconvenience in finding means of conveyance to the university",
    "Important books are not availble in the library",
    "Adequate facilities are not available in the laboratory",
    "Neighborhood environment interferes in studies",
    "Family environment interferes in studies",
    "Lectures are incomprehensible",
    "I do not get adequate time for studies",
    "Exams are held late",
    "My father/mother got involved in an extramarital relationship",
    "I could not buy the expensive bike/car my friend has bought",
    "My friend has become more popular than me amongst prospective relationship partners",
    "I have been sexually abused",
    "My parents are separated",
    "I have to accept a step parent at this stage"
];

const domainResultsTextData = [
    [
      "This also suggests that you have been able to handle your finances in an efficient way. You can identify the healthy practices you have been following and continue practicing them to help you in the future.",
      "While you can contact our peer counselors to talk about the stress you are experiencing, you can also start by identifying the stressors and coming up with healthy strategies to reduce the amount of stress.",
      "Identifying the stressors and coming up with healthy strategies is the first step towards dealing with stress. We also suggest considering to contact our peer counselors to help you along the way of dealing with the stress.",
    ],
    [
      "To help maintain a similar or better familial environment you can always practice different family bonding activities which can include anything you enjoy doing with your family and allowing each other to express their feelings.",
      "While you can contact our peer counselors to talk about the stress you are experiencing, you can also start by identifying the stressors and coming up with healthy strategies to reduce the amount of stress.",
      "Identifying the stressors and coming up with healthy strategies is the first step towards dealing with stress. We also suggest considering to contact our peer counselors to help you along the way of dealing with the stress.",
    ],
    [
      "",
      "While you can contact our peer counselors to talk about the stress you are experiencing, you can also start by identifying the stressors and coming up with healthy strategies to reduce the amount of stress.",
      "Identifying the stressors and coming up with healthy strategies is the first step towards dealing with stress. We also suggest considering to contact our peer counselors to help you along the way of dealing with the stress.",
    ],
    [
      "To avoid feeling stressed about this domain in the future you can identify ways of learning and studying that work for you the best.",
      "While you can contact our peer counselors to talk about the stress you are experiencing, you can also start by identifying the stressors and coming up with healthy strategies to reduce the amount of stress.",
      "Identifying the stressors and coming up with healthy strategies is the first step towards dealing with stress. We also suggest considering to contact our peer counselors to help you along the way of dealing with the stress.",
    ],
    [
      "You can always practice things like focusing on the effort rather than the outcome and letting go to avoid stress from this particular domain.",
      "While you can contact our peer counselors to talk about the stress you are experiencing, you can also start by identifying the stressors and coming up with healthy strategies to reduce the amount of stress.",
      "Identifying the stressors and coming up with healthy strategies is the first step towards dealing with stress. We also suggest considering to contact our peer counselors to help you along the way of dealing with the stress.",
    ],
    [
      "",
      "While you can contact our peer counselors to talk about the stress you are experiencing, you can also start by identifying the stressors and coming up with healthy strategies to reduce the amount of stress.",
      "Identifying the stressors and coming up with healthy strategies is the first step towards dealing with stress. We also suggest considering to contact our peer counselors to help you along the way of dealing with the stress.",
    ],
    [
      "",
      "While you can contact our peer counselors to talk about the stress you are experiencing, you can also start by identifying the stressors and coming up with healthy strategies to reduce the amount of stress.",
      "Identifying the stressors and coming up with healthy strategies is the first step towards dealing with stress. We also suggest considering to contact our peer counselors to help you along the way of dealing with the stress.",
    ],
    [
      "You can always practice to focus on things you can control and keep moving forward no matter what to help you deal with stress related to this domain in the future.",
      "While you can contact our peer counselors to talk about the stress you are experiencing, you can also start by identifying the stressors and coming up with healthy strategies to reduce the amount of stress.",
      "Identifying the stressors and coming up with healthy strategies is the first step towards dealing with stress. We also suggest considering to contact our peer counselors to help you along the way of dealing with the stress.",
    ],
    [
      "",
      "While you can contact our peer counselors to talk about the stress you are experiencing, you can also start by identifying the stressors and coming up with healthy strategies to reduce the amount of stress.",
      "Identifying the stressors and coming up with healthy strategies is the first step towards dealing with stress. We also suggest considering to contact our peer counselors to help you along the way of dealing with the stress.",
    ],
  ];

  const domainData = [
    {
      key: 1,
      src: financialImg,
      domainName: "Financial",
      desc: "The test measured the amount of stress you’ve experienced related to financial prospects.",
      result: "",
      text1: "level of stress in the past year in this prospect.",
      text2: "",
      color: "",
    },
    {
      key: 2,
      src: familyImg,
      domainName: "Family",
      desc: "The test measured the amount of stress you’ve experienced in regards to familial troubles.",
      result: "",
      text1: "level of stress in the past year in terms of family issues.",
      text2: "",
      color: "",
    },
    {
      key: 3,
      src: socialImg,
      domainName: "Social",
      desc: "The test measured the amount of stress you’ve experienced related to social activities and your involvement in social circles (friends, teachers, relatives).",
      result: "",
      text1: "level of stress in the past year from your social relationships.",
      text2: "",
      color: "",
    },
    {
      key: 4,
      src: educationImg,
      domainName: "Education",
      desc: "The test measured the amount of stress you’ve experienced related to your education.",
      result: "",
      text1: "level of stress in the past year in terms of your academics.",
      text2: "",
      color: "",
    },
    {
      key: 5,
      src: egoThreatImg,
      domainName: "Ego Threat",
      desc: "The test measured the amount of stress you’ve experienced related to threats to your sense of self/ego.",
      result: "",
      text1: "level of stress in the past year in this domain.",
      text2: "",
      color: "",
    },
    {
      key: 6,
      src: bereavementImg,
      domainName: "Bereavement",
      desc: "The test measured the amount of stress you’ve experienced related to any death you might have encountered in the past year.",
      result: "",
      text1: "level of stress in the past year from this particular domain.",
      text2: "",
      color: "",
    },
    {
      key: 7,
      src: separationImg,
      domainName: "Separation",
      desc: "The test measured the amount of stress you’ve experienced due to separation from your loved ones or familiar surroundings.",
      result: "",
      text1: "level of stress in the past year in this domain.",
      text2: "",
      color: "",
    },
    {
      key: 8,
      src: setBackImg,
      domainName: "Personal Setback",
      desc: "The test measured the amount of stress you’ve experienced regarding any personal setback in either your professional or personal life.",
      result: "",
      text1: "level of stress in the past year from this aspect of your life.",
      text2: "",
      color: "",
    },
    {
      key: 9,
      src: healthImg,
      domainName: "Health of Others",
      desc: "The test measured the amount of stress you’ve experienced from the change in health of those around you.",
      result: "",
      text1: "level of stress in the past year in this domain.",
      text2: "",
      color: "",
    },
  ]

export { questions, domainResultsTextData, domainData };